<template>
  <div class="flex">
    <div class="tooltip-container" :class="titleClass" style="align-self: flex-start;">
      {{ title }}
      <span ref="iconRef">
        <font-awesome-icon :icon="['fas', 'circle-info']" class="pointer" @mouseover="showTooltip" @mouseleave="hideTooltip" />
      </span>
    </div>

    <!-- Teleport tooltip to body to escape modal overflow -->
    <Teleport to="body">
      <div
        v-if="show"
        ref="tooltip"
        class="tooltip tooltip-teleported"
        v-html="innerHtml"
        :class="{
          'centered-tooltip': centered,
          'centered-left-tooltip': centeredLeft
        }"
        :style="tooltipStyle"
        @mouseenter="show = true"
        @mouseleave="hideTooltip"
      >
      </div>
    </Teleport>
  </div>
</template>
<script>
// import instance from '../../main';
// import eventBus from '../../eventBus';


export default {
  components: {
  },
  props: {
    title: String,
    titleClass: String,
    innerHtml: String,
    centered: Boolean,
    centeredLeft: Boolean,
  },
  data() {
    return{
      isLoading: true,
      show: false,
      tooltipStyle: {},
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.adjustTooltipPosition();
        });
      } else {
        this.tooltipStyle = {};
      }
    }
  },
  async mounted() {
    // addEventListener('click', () => {
    //   // if (event.target.closest('.tooltip-container') == null) {
    //     this.show = false
    //   // }
    // })
  },
  computed: {

  },
  methods: {
    showTooltip() {
      this.show = true;
    },
    hideTooltip() {
      this.show = false;
    },
    adjustTooltipPosition() {
      const tooltip = this.$refs.tooltip;
      const iconRef = this.$refs.iconRef;
      if (!tooltip || !iconRef) return;

      // Get icon position in viewport
      const iconRect = iconRef.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // Initial positioning below the icon
      let top = iconRect.bottom + 8; // 8px spacing below icon
      let left = iconRect.left;

      // Measure tooltip dimensions with temporary positioning
      this.tooltipStyle = {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        right: 'auto',
        bottom: 'auto'
      };

      this.$nextTick(() => {
        const tooltipRect = tooltip.getBoundingClientRect();

        // If tooltip goes off right edge, align to right
        if (tooltipRect.right > windowWidth - 16) {
          left = windowWidth - tooltipRect.width - 16; // 16px padding from edge
        }

        // If tooltip goes off left edge, align to left
        if (left < 16) {
          left = 16;
        }

        // If tooltip goes off bottom, position above icon instead
        if (tooltipRect.bottom > windowHeight - 16) {
          top = iconRect.top - tooltipRect.height - 8;
        }

        // If still goes off top, position at top of screen
        if (top < 16) {
          top = 16;
        }

        this.tooltipStyle = {
          position: 'fixed',
          top: `${top}px`,
          left: `${left}px`,
          right: 'auto',
          bottom: 'auto'
        };
      });
    }
  },
  created() {

  }
}

</script>

<style scoped>
/* Override default tooltip positioning for teleported tooltips */
.tooltip-teleported {
  position: fixed !important;
  z-index: 20000 !important;
  pointer-events: auto;
  width: auto !important;
  max-width: 300px;
}

.tooltip-teleported.centered-tooltip {
  transform: none !important;
}

.tooltip-teleported.centered-left-tooltip {
  transform: none !important;
}
</style>
